import React from 'react';

import { Alert, Space, Statistic, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatAmount } from '@utils/currency';

const { Text } = Typography;

// 倉租試算結果（共用於費率卡表單與當前費率卡檢視）。result 為 preview 端點回傳的
// { mode, billable_units, unit_price, amount, breakdown }。
const StoragePreviewResult = ({ result }) => {
  const { t } = useTranslation();
  const prefix = 'operator.merchants.show';
  if (!result) return null;

  // 只列「有設單價」的儲位類型；有庫存但未設價的類型不顯示（= 不收費，刻意留白）
  const shelfTypes = (result.breakdown?.shelf_types || []).filter(st => Number(st.unit_price) > 0);

  return (
    <Alert
      style={{ marginTop: 12 }}
      type="success"
      showIcon
      message={
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
          <Text type="secondary" style={{ fontSize: 12 }}>{t(`${prefix}.preview.title`)}</Text>
          <Statistic
            value={Number(result.amount)}
            precision={2}
            prefix="$"
            valueStyle={{ fontSize: 24, fontWeight: 600, lineHeight: 1.3, color: '#389e0d' }}
          />
          <Text type="secondary" style={{ fontSize: 12 }}>{t(`${prefix}.preview.basis`)}</Text>
        </Space>
      }
      description={
        <div style={{ marginTop: 8 }}>
          {result.mode === 'by_shelf' && shelfTypes.map(st => (
            <div key={st.shelf_type_id} style={{ fontSize: 12, marginTop: 2 }}>
              <Text type="secondary">
                {t(`${prefix}.preview.shelf_line`, {
                  name: st.name,
                  count: st.count,
                  unit_price: formatAmount(st.unit_price),
                  subtotal: formatAmount(st.subtotal),
                })}
              </Text>
            </div>
          ))}
          {result.mode !== 'by_shelf' && result.mode !== 'none' && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {t(`${prefix}.preview.units_line`, {
                units: result.billable_units,
                unit_price: formatAmount(result.unit_price),
              })}
            </Text>
          )}
        </div>
      }
    />
  );
};

export default StoragePreviewResult;
